import {
  AlignItems,
  Box,
  JustifyContent,
  Visibility,
} from "@gocardless/flux-react";

import GoCardlessLogo, {
  type GoCardlessLogoProps,
} from "src/components/GoCardlessLogo";

type LogoVariant = GoCardlessLogoProps["variant"];

interface LogoHeaderProps {
  /**
   * The url applied to the logo's wrapping link
   */
  logoUrl?: string;
  /**
   * The variant of the logo to be displayed
   * @default "dark"
   */
  logoVariant?: LogoVariant | { default: LogoVariant; lg: LogoVariant };
  /**
   * Content to be displayed on the right side of the header
   * @default null
   */
  rightContent?: React.ReactNode;
}

export const LogoHeader = ({
  logoVariant = "dark",
  rightContent = null,
  logoUrl,
}: LogoHeaderProps) => {
  const lgLogoVariant =
    typeof logoVariant === "object" ? logoVariant.lg : logoVariant;
  const defaultLogoVariant =
    typeof logoVariant === "object" ? logoVariant.default : logoVariant;

  return (
    <Box
      layout="flex"
      justifyContent={JustifyContent.SpaceBetween}
      alignItems={AlignItems.Center}
    >
      <Visibility visible={["none", null, null, "block"]}>
        <GoCardlessLogo logoURL={logoUrl} variant={lgLogoVariant} size="lg" />
      </Visibility>
      <Visibility visible={["block", null, null, "none"]}>
        <GoCardlessLogo
          logoURL={logoUrl}
          variant={defaultLogoVariant}
          size="xs"
        />
      </Visibility>
      <Box>{rightContent}</Box>
    </Box>
  );
};
